import useWorldState from 'Components/World/WorldStateManager';
import styles from './styles.module.scss';
import { useCallback, useEffect } from 'react';
import DisteudoGate from 'Components/World/DisteudoGate';
import { trackEvent } from 'utils/analytics';

const L2SubscriptionConfirmation=({})=>{
  const {navTo} = useWorldState(state=>({navTo:state.navTo}))

  // Landing here is the signal that the Mailchimp round-trip actually
  // completed, which the submit event alone cannot tell you.
  useEffect(()=>{
    trackEvent({
      category: 'subscription',
      action: 'subscription_confirmation-viewed'
    })
  },[])
  const navHome = useCallback(()=>{
    if (!navTo) return
    navTo('/')
  },[navTo])
  return (
    <div className={styles.L2SubscriptionConfirmation}>
      <DisteudoGate>
        <p>You should have an email to verify your subscription.</p> 
        <p>Once you click the link in there you'll be all set.</p>
        <button onClick={navHome}>OK</button>
      </DisteudoGate>
    </div>
  )
}

export default L2SubscriptionConfirmation